module.exports = __webpack_public_path__ + "img/dugout-lounge-tables-04.6306f5ed.jpeg";